var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.982,
    height: 33.896,
    viewBox: "0 0 35.982 33.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38369",
    "data-name": "Group 38369",
    transform: "translate(-0.465 -0.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.987,0l9,16.948-9,16.948H9L0,16.948,9,0Z",
    transform: "translate(0.465 0.372)",
    fill: "#537cbe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_",
    transform: "translate(9.465 8.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    d: "M207.291,5.656h-8.838a.532.532,0,0,0-.532.532V9.942l.385-.45a1.224,1.224,0,0,1,.679-.4V6.72h7.774v6.948h-7.774V12.505l-.239.28a1.235,1.235,0,0,1-.824.426V14.2a.532.532,0,0,0,.532.532h2.87l-1.458,6.62a.55.55,0,1,0,1.075.237l1.51-6.858h.878l1.51,6.858a.55.55,0,1,0,1.075-.237l-1.458-6.62h2.836a.532.532,0,0,0,.532-.532V6.188A.532.532,0,0,0,207.291,5.656Z",
    transform: "translate(-191.197 -5.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    d: "M172.557,93.414a.205.205,0,0,0-.266-.116L169.157,94.4a.688.688,0,0,0-.942.1l-.994,1.161-.882-.756c.006.062.019.123.019.187v1.641l.491.42a.688.688,0,0,0,.97-.075L169,95.695l.955-.558,2.512-1.47A.2.2,0,0,0,172.557,93.414Z",
    transform: "translate(-160.688 -90.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    d: "M3.734,105.776h-.59a1.378,1.378,0,0,0-1.1.555L.229,108a.688.688,0,0,0-.054.971l1.479,1.651a.688.688,0,1,0,1.024-.918l-1.019-1.138,1.448-1.3-.843,1.146.825.921a1.234,1.234,0,0,1-1.329,1.989s.006,3.182.006,6.589a.825.825,0,1,0,1.65,0V113h.55v4.918a1.365,1.365,0,0,1-.172.653.816.816,0,0,0,.5.172.825.825,0,0,0,.825-.825c0-3.406,0-1.978,0-10.754A1.385,1.385,0,0,0,3.734,105.776Z",
    transform: "translate(0 -102.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    d: "M54.75,5.025A1.608,1.608,0,0,0,57.092,3.6,1.608,1.608,0,1,0,54.75,5.025Z",
    transform: "translate(-52.046 -1.995)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducatorIcon);
export default __webpack_public_path__ + "static/media/educatorIcon.5130b3a2a6b6cb9fd9809fb7b7cf9ac4.svg";
export { ForwardRef as ReactComponent };